// removed by extract-text-webpack-plugin
module.exports = {"tab-container":"tab-container__1lpmh","selected":"selected__1oaRd"};


//////////////////
// WEBPACK FOOTER
// ./styles/home/tabs.scss
// module id = 599
// module chunks = 68